import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';
import { createCapsuleGroup } from '../components/Capsule';

// import { useGlobalState } from '../context/GlobalState';
// import { deusSocket } from '../utils/api';
// import Header from './components/Header';
// import AudioPlayer from './components/AudioPlayer';
// import Footer from './components/Footer';

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass';

function Home() {
  const canvasRef = useRef(null);

  useEffect(() => {
    // ===== Basic Setup =====
    const canvas = canvasRef.current;
    const renderer = new THREE.WebGLRenderer({ canvas, antialias: true });
    renderer.setSize(window.innerWidth, window.innerHeight);

    const scene = new THREE.Scene();
    scene.background = new THREE.Color(0x000000);

    // Camera
    const camera = new THREE.PerspectiveCamera(
      75,
      window.innerWidth / window.innerHeight,
      0.1,
      1000
    );
    camera.position.set(0, 0, 30);
    scene.add(camera);

    // Lights
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
    scene.add(ambientLight);

    const dirLight = new THREE.DirectionalLight(0xffffff, 0.6);
    dirLight.position.set(5, 10, 5);
    scene.add(dirLight);

    // ----------------------------------------------
    // Grab the capsule group from the extracted file
    // ----------------------------------------------
    const capsuleGroup = createCapsuleGroup();
    scene.add(capsuleGroup);

    // ----- Post-processing Setup -----
    const composer = new EffectComposer(renderer);
    composer.addPass(new RenderPass(scene, camera));

    const bloomPass = new UnrealBloomPass(
      new THREE.Vector2(window.innerWidth, window.innerHeight),
      0,
      0,
      0
    );
    composer.addPass(bloomPass);

    // ===== Starfield Setup =====
    const starGeometry = new THREE.BufferGeometry();
    const starCount = 1000;
    const starVertices = [];

    for (let i = 0; i < starCount; i++) {
      const x = THREE.MathUtils.randFloatSpread(2000);
      const y = THREE.MathUtils.randFloatSpread(2000);
      const z = THREE.MathUtils.randFloatSpread(2000);
      starVertices.push(x, y, z);
    }

    starGeometry.setAttribute('position', new THREE.Float32BufferAttribute(starVertices, 3));

    const starMaterial = new THREE.PointsMaterial({
      color: 0xffffff,
      size: 1,
      sizeAttenuation: true,
      transparent: true,
      opacity: 0.8,
    });

    const stars = new THREE.Points(starGeometry, starMaterial);
    scene.add(stars);

    // ===== Resize Handling =====
    function onWindowResize() {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
      composer.setSize(window.innerWidth, window.innerHeight);
    }
    window.addEventListener('resize', onWindowResize);

    // ===== Animation Loop =====
    function animate() {
      requestAnimationFrame(animate);

      // Animate the capsule
      capsuleGroup.rotation.y += 0.02;
      capsuleGroup.rotation.x += 0.01;

      // Rotate stars for parallax effect
      stars.rotation.y += 0.0002;
      stars.rotation.x += 0.0001;

      composer.render();
    }
    animate();

    // Cleanup on unmount
    return () => {
      window.removeEventListener('resize', onWindowResize);
      renderer.dispose();
      composer.dispose();
    };
  }, []);

  return (
    <div style={{ 
      margin: 0, 
      overflow: 'hidden', 
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 0
    }}>
      <canvas ref={canvasRef} />
    </div>
  );
}

export default Home;
